import React from "react";
import LegalDocumentPage from "../components/legal/LegalDocumentPage";
import publicLegalDocuments from "../legal/publicLegalDocuments.json";

export default function SubprocessorsPage() {
  return <LegalDocumentPage document={publicLegalDocuments.subprocessors} />;
}
